import { Component, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';
import Order from 'src/smoothr-web-app-core/models/Order';

@Component({
	selector: 'app-order-error-modal',
	templateUrl: './order-error-modal.component.html',
	styleUrls: ['./order-error-modal.component.scss'],
	standalone: false,
})
export class OrderErrorModalComponent {
	title: string;
	text: Order;
	applyButtonText: string;
	cancelButtonText: string;

	private modalCtrl = inject(ModalController);

	static async show(
		modalCtrl: ModalController,
		title: string,
		text: string,
		applyButtonText: string = '',
		cancelButtonText: string = 'Cancel'
	): Promise<Boolean> {
		const modal = await modalCtrl.create({
			component: OrderErrorModalComponent,
			componentProps: {
				title,
				text,
				applyButtonText,
				cancelButtonText,
			},
			cssClass: 'auto-height item-modal reduced-width-modal',
			showBackdrop: true,
			backdropDismiss: true,
		});

		await modal.present();
		const result = (await modal.onDidDismiss()).data;
		return result;
	}

	close(res: boolean = false) {
		this.modalCtrl.dismiss(res);
	}
}
